import React from 'react'
import Axios from "axios";
import server from 'util/Server';
import Storage from 'util/store/Storage'
import { sessionCaducada } from 'util/funciones'

const PARAMETRO_TIRILLA_LOGO = "TIRILLA_LOGO";

export const getTirillaLogo = async (identificadorEstacion: string): Promise<any> => {
    const { empresasHijos } = Storage.getState()
    const PUERTO_CENTURY = server.puertoCentury ? server.puertoCentury : '7001'
    const URL_GET_PARAMETROS = server.host + PUERTO_CENTURY + `/api/v2/parametrovalor?limit=999999999&tipoNegocio=5,6,7,8,9,10,11&empresasNegocioId=${empresasHijos}&empresa_id=${identificadorEstacion}`

    try {
        const { data } = await Axios.get(URL_GET_PARAMETROS, { headers: { Authorization: server.obtenerToken(), } })

        if (data.data.length > 0) {
            const parametro = data.data.find((params: any) => params.nombre == PARAMETRO_TIRILLA_LOGO)
            if (parametro) {
                return `data:image/png;base64,${parametro.valor}`
            }
        }

        return ""

    } catch (error) {
        console.log(error)
        return ""
    }
}